import angular from 'angular';
import {
  ssDialogService,
} from 'app/services';
import editITCoreProceduresDialog from './dialog.editITCoreProceduresDialog';
import controller from './it-core-procedures.controller';
import directive from './it-core-procedures.directive';


export default angular.module('app.components.advisory.bcp.itCoreProcedures', [
  ssDialogService,
  editITCoreProceduresDialog,
])
  .directive('bcpItCoreProcedures', directive)
  .controller('ITCoreProceduresController', controller)
  .name;

console.log('app.components.advisory.bcp.itCoreProcedures created');
